import axios from "axios";
import { createContext, useContext, useReducer } from "react";
import Profile_reducer from "../reducer/Profile_reducer";
import {
  DELETE_BROTHER_BEGIN,
  DELETE_BROTHER_ERROR,
  DELETE_BROTHER_SUCCESS,
  DELETE_OTHER_IMG_BEGIN,
  DELETE_OTHER_IMG_ERROR,
  DELETE_OTHER_IMG_SUCCESS,
  DELETE_SISTER_BEGIN,
  DELETE_SISTER_ERROR,
  DELETE_SISTER_SUCCESS,
  GET_PROFILE_BEGIN,
  GET_PROFILE_ERROR,
  GET_PROFILE_SUCCESS,
  UPDATE_PROFILE_BEGIN,
  UPDATE_PROFILE_ERROR,
  UPDATE_PROFILE_SUCCESS,
} from "../utils/action";
import {
  ACCEPT_HEADER,
  delete_brother_url,
  delete_other_image_url,
  delete_sister_url,
  get_profile_url,
  update_profile_url,
} from "../utils/constant";
import { useLoginContext } from "../context/Login_context";
import Notification from "../utils/Notification";

const ProfileContext = createContext();

const initialState = {
  profile_loading: false,
  profile_data: {},
  update_loading: false,
  delete_Bro_loading: false,
  delete_Sis_loading: false,
  delete_other_img_load: false,
};

export const ProfileProvider = ({ children }) => {
  const [state, dispatch] = useReducer(Profile_reducer, initialState);
  const { setLogout, setFormComplete } = useLoginContext();

  // ─── GET PROFILE ───────────────────────────────────────────────────────────
  const GetProfileDate = async (navigate) => {
    const token = localStorage.getItem("token");
    dispatch({ type: GET_PROFILE_BEGIN });

    axios
      .get(get_profile_url, {
        headers: {
          Accept: ACCEPT_HEADER,
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        if (res.data.status === "Token is Expired") {
          setLogout(navigate);
        } else if (res.data.success === 1) {
          dispatch({ type: GET_PROFILE_SUCCESS, payload: res.data.data });
        } else {
          dispatch({ type: GET_PROFILE_ERROR });
        }
      })
      .catch((err) => {
        console.log("Error in Get Profile Api ", err);
        dispatch({ type: GET_PROFILE_ERROR });
      });
  };

  // ─── UPDATE PROFILE ────────────────────────────────────────────────────────
  const UpdateProfile = async (formdata, navigate) => {
    const token = localStorage.getItem("token");
    dispatch({ type: UPDATE_PROFILE_BEGIN });

    axios
      .post(update_profile_url, formdata, {
        headers: {
          Accept: ACCEPT_HEADER,
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        if (res.data.status === "Token is Expired") {
          setLogout();
        } else if (res.data.success === 1) {
          Notification("success", res.data.message);
          setFormComplete();

          GetProfileDate(navigate);
          navigate("/home");
          dispatch({ type: UPDATE_PROFILE_SUCCESS });
        }
      })
      .catch((err) => {
        console.log(
          "Error in Update Profile Api ",
          JSON.stringify(err, null, 2),
        );
        dispatch({ type: UPDATE_PROFILE_ERROR });
      });
  };

  // ─── DELETE BROTHER ────────────────────────────────────────────────────────
  const DeleteBrother = async (formdata, navigate) => {
    const token = localStorage.getItem("token");
    dispatch({ type: DELETE_BROTHER_BEGIN });

    axios
      .post(delete_brother_url, formdata, {
        headers: {
          Accept: ACCEPT_HEADER,
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        if (res.data.status === "Token is Expired") {
          setLogout();
        } else if (res.data.success === 1) {
          Notification("success", res.data.message);
          GetProfileDate(navigate);
          dispatch({ type: DELETE_BROTHER_SUCCESS });
        } else {
          dispatch({ type: DELETE_BROTHER_ERROR });
        }
      })
      .catch((err) => {
        console.log("Error in delete brother Api ", err);
        dispatch({ type: DELETE_BROTHER_ERROR });
      });
  };

  // ─── DELETE SISTER ─────────────────────────────────────────────────────────
  const DeleteSister = async (formdata, navigate) => {
    const token = localStorage.getItem("token");
    dispatch({ type: DELETE_SISTER_BEGIN });

    axios
      .post(delete_sister_url, formdata, {
        headers: {
          Accept: ACCEPT_HEADER,
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        if (res.data.status === "Token is Expired") {
          setLogout();
        } else if (res.data.success === 1) {
          Notification("success", res.data.message);
          GetProfileDate(navigate);
          dispatch({ type: DELETE_SISTER_SUCCESS });
        } else {
          dispatch({ type: DELETE_SISTER_ERROR });
        }
      })
      .catch((err) => {
        console.log("Error in delete sister Api ", err);
        dispatch({ type: DELETE_SISTER_ERROR });
      });
  };

  // ─── DELETE OTHER IMAGE ────────────────────────────────────────────────────
  const DeleteOtherImage = async (formdata, navigate) => {
    const token = localStorage.getItem("token");
    dispatch({ type: DELETE_OTHER_IMG_BEGIN });

    axios
      .post(delete_other_image_url, formdata, {
        headers: {
          Accept: ACCEPT_HEADER,
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        if (res.data.status === "Token is Expired") {
          setLogout();
        } else if (res.data.success === 1) {
          Notification("success", res.data.message);
          GetProfileDate(navigate);
          dispatch({ type: DELETE_OTHER_IMG_SUCCESS });
        } else {
          dispatch({ type: DELETE_OTHER_IMG_ERROR });
        }
      })
      .catch((err) => {
        console.log("Error in delete other image Api ", err);
        dispatch({ type: DELETE_OTHER_IMG_ERROR });
      });
  };

  return (
    <ProfileContext.Provider
      value={{
        ...state,
        GetProfileDate,
        UpdateProfile,
        DeleteBrother,
        DeleteSister,
        DeleteOtherImage,
      }}
    >
      {children}
    </ProfileContext.Provider>
  );
};

export const useProfileContext = () => {
  return useContext(ProfileContext);
};
